import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {ImageCroppedEvent, ImageTransform, LoadedImage} from 'ngx-image-cropper';
import {ModalConfig} from '@shared/components/modal/modal.interface';
import {ModalComponent} from '@shared/components/modal/modal.component';
import {STRING_CONSTANTS} from '@config/constants/string.constants';
import {FormArray, FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {UploadService} from '@services/upload.service';

@Component({
  selector: 'app-image-upload-cropper',
  templateUrl: './image-upload-cropper.component.html',
  styleUrls: ['./image-upload-cropper.component.scss'],
})
export class ImageUploadCropperComponent implements OnInit {
  @Input() idx: string | number = '';
  @Input() maxLimit: number = 5;
  @Input() data?: { id: string; images: string[] };

  @Output() fileUrl = new EventEmitter();
  @Output() removeFile = new EventEmitter();
  @Output() editFile = new EventEmitter();

  imageChangedEvent: any = '';
  croppedImage: SafeUrl = '';
  croppedImageEvent: ImageCroppedEvent;
  canvasRotation = 0;
  imageUrl: string = '';
  idChangeImage: number | undefined = undefined;

  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  @ViewChild('modal') modal: ModalComponent;
  modalConfig: ModalConfig = {
    modalTitle: 'EDIT FOTO',
    showHeader: false,
    hideCloseButton: () => true,
    onDismiss: () => this.onSaveCrop(),
    dismissButtonLabel: 'Simpan',
  };

  selectedFiles: FileList | any;
  // previewSubject: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  // preview$?: Observable<string[]>;

  uploadForm: FormGroup;
  isLoading = new BehaviorSubject<boolean>(false);

  constructor(private sanitizer: DomSanitizer, private uploadService: UploadService, private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.uploadForm = this.fb.group({
      fileImages: this.fb.array([]),
    });

    if (this.data) {
      // data to fileImages format
      this.data.images.forEach((_item: any) => {
        this.createImage({
          id: this.data?.id as string,
          url: _item,
        });
      });

      this.fileUrl.emit(this.fileImages.value);
    }
  }

  get fileImages() {
    return this.uploadForm.get('fileImages') as FormArray;
  }

  createImage(img: { id: string | number; url: string }) {
    const _image = new FormControl(img);
    (<FormArray>this.uploadForm.get('fileImages')).push(_image);
  }

  updateImage(url: string) {
    (<FormArray>this.uploadForm.get('fileImages')).at(this.idChangeImage as number).setValue({
      id: this.idChangeImage,
      url
    });
    this.fileImages.updateValueAndValidity();
    this.fileImages.markAsDirty();
  }

  handleDropFiles(evt: any) {
    const _currentFileImagesNum = this.fileImages.length;

    if (evt.length > this.maxLimit) {
      return setTimeout(() => this.uploadService.errorMaxFileUpload('Upload Maksimal hanya 5 file!'), 500);
    }

    if (evt.length + _currentFileImagesNum > this.maxLimit) {
      return setTimeout(() => this.uploadService.errorMaxFileUpload('Upload Maksimal hanya 5 file!'), 500);
    }

    return this.uploadFiles(evt);
  }

  onFileSelected(evt: any) {
    const _currentFileImagesNum = this.fileImages.length;
    this.selectedFiles = evt.target.files;

    if (this.selectedFiles.length > this.maxLimit) {
      return setTimeout(() => this.uploadService.errorMaxFileUpload('Upload Maksimal hanya 5 file!'), 500);
    }

    if (this.selectedFiles.length + _currentFileImagesNum > this.maxLimit) {
      return setTimeout(() => this.uploadService.errorMaxFileUpload('Upload Maksimal hanya 5 file!'), 500);
    }

    this.fileChangeEvent(evt);
    // return this.uploadFiles(this.selectedFiles);
  }

  uploadFiles(files: FileList) {
    if (!files) {
      return;
    }

    const _numFiles = files.length;
    if (_numFiles > this.maxLimit) {
      return this.uploadService.errorMaxFileUpload('Upload Maksimal hanya 5 file!');
    }

    for (let i = 0; i < _numFiles; i++) {
      this.handleUpload(this.idx, files[i]);
    }
  }

  handleUpload(id: number | string, file: File) {
    this.isLoading.next(true);
    this.uploadService.upload(file).subscribe((resp) => {
      if (resp && resp.success) {
        const {url} = resp.data;
        if (this.idChangeImage !== undefined) {
          this.updateImage(url);
          this.editFile.emit({id: this.idChangeImage, url});
          this.idChangeImage = undefined;
        } else {
          this.createImage({id, url});
          this.fileUrl.emit(this.fileImages.value);
        }
        this.isLoading.next(false);
      }
    });
  }

  onDeleteFileImage(index: number, img: { id: string; url: string }) {
    this.fileImages.removeAt(index);
    this.removeFile.emit(img);
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.modal.open().then();
  }

  imageCropped(event: ImageCroppedEvent) {
    if (!event.objectUrl) return;
    this.croppedImageEvent = event;

    // if (event.objectUrl != null) {
    //   console.log('event', event);
    //   this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    // }
    // event.blob can be used to upload the cropped image
  }

  imageLoaded(image: LoadedImage) {
    // show cropper
  }

  cropperReady() {
    // cropper ready
  }

  loadImageFailed() {
    // show message
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.1,
    };
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.1,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0,
    };
  }

  onSaveCrop() {
    const image = this.selectedFiles[0];
    const file = this.blobToFile(this.croppedImageEvent.blob as Blob, image.name);
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    this.uploadFiles(dataTransfer.files);
    return true;
  }

  blobToFile = (blob: Blob, fileName: string) => new File([blob], fileName, {type: blob.type});

  async onEditFileImage(i: number) {
    this.imageUrl = this.fileImages.value[i].url;
    this.idChangeImage = i;
    this.fileChangeEvent('');
  }

  onReplaceFileImage(i: number) {
    const fileInput = document.getElementById('fileImages__' + this.idx) as HTMLInputElement;
    if (fileInput) {
      this.idChangeImage = i;
      fileInput.click();
    }
  }

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
}
